import { Link, useLocation } from "react-router-dom";

/**
 * Navigation latérale du back-office admin, avec état "lien actif". Porté
 * depuis apps/web/components/admin/AdminSidebarNav.tsx (seul changement :
 * `next/navigation` `usePathname()` → `react-router-dom` `useLocation().pathname`,
 * `next/link` → `Link`/`to`).
 */
const NAV_ITEMS = [
  { href: "/admin", label: "Tableau de bord" },
  { href: "/admin/commandes", label: "Commandes" },
  { href: "/admin/catalogue", label: "Catalogue" },
  { href: "/admin/stock", label: "Stock" },
  { href: "/admin/clients", label: "Clients" },
  { href: "/admin/parametres", label: "Paramètres" },
];

export function AdminSidebarNav() {
  const { pathname } = useLocation();

  return (
    <nav aria-label="Navigation admin" className="flex flex-col gap-1">
      {NAV_ITEMS.map((item) => {
        const isActive = item.href === "/admin" ? pathname === "/admin" : pathname.startsWith(item.href);
        return (
          <Link
            key={item.href}
            to={item.href}
            className={[
              "rounded-sm px-3 py-2 text-sm font-medium transition-colors",
              isActive ? "bg-gold text-navy" : "text-cream hover:bg-white/10",
            ].join(" ")}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
